import {Area} from './area';

export interface Home {
    areas: Area[],
    usage: number,
    storage: number
}
